<template lang="pug">
main
  PmHeader
  .section
    .container
      br
      article.message.is-info
        .message-header
          p Contacto
        .message-body
          p
            strong Jorge Luis Quiguango
          strong Correo Electrónico:
          |  info@mestizos.dev
          br
          strong Web:
          |
          a(href="https://mestizos.dev" target="_blank")
          |  mestizos.dev
          br
          strong Teléfono:
          |  0969528480 &#9742;
        br

</template>

<script>
import PmHeader from '../components/layout/Header.vue'

export default {
  components: {
    PmHeader
  }
}

</script>


<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: center;
}
</style>
